import { TNode } from 'tdesign-react/es/common';

import { fetchCAIModelList, fetchKnowledgeList, fetchSkillList, fetchTagList, fetchTemplateList, fetchVoiceList, getBotOptions } from '@/services/bot';

interface BotOption {
  value: string,
  label: string,
  opt: any,
  content?: string | TNode
}

export const fetchBotsOptions = async () => {
  const ret = await getBotOptions({ page: 1, size: 999 });
  return {
    list: ret.list.map(item => ({ label: item.name || '未命名', value: item.id, opt: item })) as BotOption[],
    pageInfo: ret.pageInfo,
  };
};

export const fetchKnowledgeOptions = async () => {
  const ret = await fetchKnowledgeList();
  return {
    list: ret.map(item => ({ label: item.name, value: item.id, opt: item })),
  };
};

export const fetchVoiceOptions = async () => {
  const ret = await fetchVoiceList();
  return {
    list: ret.map(item => ({ label: item.voiceName, value: `${item.voiceId}`, opt: item })),
  };
};

export const fetchTemplateOptions = async () => {
  const ret = await fetchTemplateList();
  return {
    list: ret.map(item => ({ label: `${item.versionName}`, value: item.id, opt: item })),
  };
};

export const fetchModelOptions = async () => {
  const ret = await fetchCAIModelList();
  return {
    list: ret.map(item => ({ label: item.name, value: `${item.id}`, opt: item })),
  };
};

export const fetchSkillOptions = async () => {
  const ret = await fetchSkillList();
  return {
    list: ret.map(item => ({ label: item.name, value: item.id, opt: item })),
  };
};

export const fetchTagOptions = async () => {
  const ret = await fetchTagList();
  return {
    list: ret.map(item => ({ label: item.name, value: item.name, opt: item })),
  };
};
